import { moveToWebview } from './moveToWebview';
import { moveToToday } from './moveToToday';
import { moveToSearch } from './moveToSearch';
import { moveToScreens } from './moveToScreens';
import { moveToHome } from './moveToHome';
import { moveToLikeFolders } from './moveToLikeFolders';

export const useCommonNavigator = () => {
  return {
    moveToWebview,
    moveToToday,
    moveToSearch,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
  };
};